/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputReviewPracticeAnswerStatus } from '../models';
// @ts-ignore
import type { InputUpdateByCitizenPracticeAnswerStatus } from '../models';
// @ts-ignore
import type { PracticeAnswerStatus } from '../models';
/**
 * PracticeAnswerApi - axios parameter creator
 * @export
 */
export const PracticeAnswerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get citizens practice answer status for service request id
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCitizensPracticeAnswerStatusForServiceRequestId: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('getCitizensPracticeAnswerStatusForServiceRequestId', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/practiceAnswer/{serviceRequestId}/citizen`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get practice answer status for service request id
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticeAnswerStatusForServiceRequestId: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('getPracticeAnswerStatusForServiceRequestId', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/practiceAnswer/{serviceRequestId}/caf`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Review practice answer status
         * @param {number} serviceRequestId 
         * @param {InputReviewPracticeAnswerStatus} [inputReviewPracticeAnswerStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPracticeAnswerStatus: async (serviceRequestId: number, inputReviewPracticeAnswerStatus?: InputReviewPracticeAnswerStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('reviewPracticeAnswerStatus', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/practiceAnswer/{serviceRequestId}/caf`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputReviewPracticeAnswerStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update by citizen practice answer status
         * @param {number} serviceRequestId 
         * @param {InputUpdateByCitizenPracticeAnswerStatus} [inputUpdateByCitizenPracticeAnswerStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateByCitizenPracticeAnswerStatus: async (serviceRequestId: number, inputUpdateByCitizenPracticeAnswerStatus?: InputUpdateByCitizenPracticeAnswerStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('updateByCitizenPracticeAnswerStatus', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/practiceAnswer/{serviceRequestId}/citizen`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputUpdateByCitizenPracticeAnswerStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticeAnswerApi - functional programming interface
 * @export
 */
export const PracticeAnswerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticeAnswerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get citizens practice answer status for service request id
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCitizensPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PracticeAnswerStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCitizensPracticeAnswerStatusForServiceRequestId(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticeAnswerApi.getCitizensPracticeAnswerStatusForServiceRequestId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get practice answer status for service request id
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PracticeAnswerStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticeAnswerStatusForServiceRequestId(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticeAnswerApi.getPracticeAnswerStatusForServiceRequestId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Review practice answer status
         * @param {number} serviceRequestId 
         * @param {InputReviewPracticeAnswerStatus} [inputReviewPracticeAnswerStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPracticeAnswerStatus(serviceRequestId: number, inputReviewPracticeAnswerStatus?: InputReviewPracticeAnswerStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeAnswerStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPracticeAnswerStatus(serviceRequestId, inputReviewPracticeAnswerStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticeAnswerApi.reviewPracticeAnswerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update by citizen practice answer status
         * @param {number} serviceRequestId 
         * @param {InputUpdateByCitizenPracticeAnswerStatus} [inputUpdateByCitizenPracticeAnswerStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateByCitizenPracticeAnswerStatus(serviceRequestId: number, inputUpdateByCitizenPracticeAnswerStatus?: InputUpdateByCitizenPracticeAnswerStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeAnswerStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateByCitizenPracticeAnswerStatus(serviceRequestId, inputUpdateByCitizenPracticeAnswerStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticeAnswerApi.updateByCitizenPracticeAnswerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticeAnswerApi - factory interface
 * @export
 */
export const PracticeAnswerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticeAnswerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get citizens practice answer status for service request id
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCitizensPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticeAnswerStatus>> {
            return localVarFp.getCitizensPracticeAnswerStatusForServiceRequestId(serviceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get practice answer status for service request id
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticeAnswerStatus>> {
            return localVarFp.getPracticeAnswerStatusForServiceRequestId(serviceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Review practice answer status
         * @param {number} serviceRequestId 
         * @param {InputReviewPracticeAnswerStatus} [inputReviewPracticeAnswerStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPracticeAnswerStatus(serviceRequestId: number, inputReviewPracticeAnswerStatus?: InputReviewPracticeAnswerStatus, options?: RawAxiosRequestConfig): AxiosPromise<PracticeAnswerStatus> {
            return localVarFp.reviewPracticeAnswerStatus(serviceRequestId, inputReviewPracticeAnswerStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update by citizen practice answer status
         * @param {number} serviceRequestId 
         * @param {InputUpdateByCitizenPracticeAnswerStatus} [inputUpdateByCitizenPracticeAnswerStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateByCitizenPracticeAnswerStatus(serviceRequestId: number, inputUpdateByCitizenPracticeAnswerStatus?: InputUpdateByCitizenPracticeAnswerStatus, options?: RawAxiosRequestConfig): AxiosPromise<PracticeAnswerStatus> {
            return localVarFp.updateByCitizenPracticeAnswerStatus(serviceRequestId, inputUpdateByCitizenPracticeAnswerStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticeAnswerApi - interface
 * @export
 * @interface PracticeAnswerApi
 */
export interface PracticeAnswerApiInterface {
    /**
     * 
     * @summary Get citizens practice answer status for service request id
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApiInterface
     */
    getCitizensPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticeAnswerStatus>>;

    /**
     * 
     * @summary Get practice answer status for service request id
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApiInterface
     */
    getPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticeAnswerStatus>>;

    /**
     * 
     * @summary Review practice answer status
     * @param {number} serviceRequestId 
     * @param {InputReviewPracticeAnswerStatus} [inputReviewPracticeAnswerStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApiInterface
     */
    reviewPracticeAnswerStatus(serviceRequestId: number, inputReviewPracticeAnswerStatus?: InputReviewPracticeAnswerStatus, options?: RawAxiosRequestConfig): AxiosPromise<PracticeAnswerStatus>;

    /**
     * 
     * @summary Update by citizen practice answer status
     * @param {number} serviceRequestId 
     * @param {InputUpdateByCitizenPracticeAnswerStatus} [inputUpdateByCitizenPracticeAnswerStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApiInterface
     */
    updateByCitizenPracticeAnswerStatus(serviceRequestId: number, inputUpdateByCitizenPracticeAnswerStatus?: InputUpdateByCitizenPracticeAnswerStatus, options?: RawAxiosRequestConfig): AxiosPromise<PracticeAnswerStatus>;

}

/**
 * PracticeAnswerApi - object-oriented interface
 * @export
 * @class PracticeAnswerApi
 * @extends {BaseAPI}
 */
export class PracticeAnswerApi extends BaseAPI implements PracticeAnswerApiInterface {
    /**
     * 
     * @summary Get citizens practice answer status for service request id
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApi
     */
    public getCitizensPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return PracticeAnswerApiFp(this.configuration).getCitizensPracticeAnswerStatusForServiceRequestId(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get practice answer status for service request id
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApi
     */
    public getPracticeAnswerStatusForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return PracticeAnswerApiFp(this.configuration).getPracticeAnswerStatusForServiceRequestId(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Review practice answer status
     * @param {number} serviceRequestId 
     * @param {InputReviewPracticeAnswerStatus} [inputReviewPracticeAnswerStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApi
     */
    public reviewPracticeAnswerStatus(serviceRequestId: number, inputReviewPracticeAnswerStatus?: InputReviewPracticeAnswerStatus, options?: RawAxiosRequestConfig) {
        return PracticeAnswerApiFp(this.configuration).reviewPracticeAnswerStatus(serviceRequestId, inputReviewPracticeAnswerStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update by citizen practice answer status
     * @param {number} serviceRequestId 
     * @param {InputUpdateByCitizenPracticeAnswerStatus} [inputUpdateByCitizenPracticeAnswerStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeAnswerApi
     */
    public updateByCitizenPracticeAnswerStatus(serviceRequestId: number, inputUpdateByCitizenPracticeAnswerStatus?: InputUpdateByCitizenPracticeAnswerStatus, options?: RawAxiosRequestConfig) {
        return PracticeAnswerApiFp(this.configuration).updateByCitizenPracticeAnswerStatus(serviceRequestId, inputUpdateByCitizenPracticeAnswerStatus, options).then((request) => request(this.axios, this.basePath));
    }
}

